import {
  // countBy,
  get,
  groupBy,
  isNumber,
} from 'lodash-es';

import logger from '../../../../../core/logger';

import { getFieldLimitationsErrors } from './formDataHelper';

const AvailableVisibilityConditions = {
  // Wartość równa (=).
  Equal: 'Equal',
  // Wartość większa (>).
  Greater: 'Greater',
  // Wartość większa lub równa (>=).
  GreaterOrEqual: 'GreaterOrEqual',
  // Wartość mniejsza (<).
  Less: 'Less',
  // Wartość mniejsza lub równa (<=).
  LessOrEqual: 'LessOrEqual',
  // Wartość różna (!=).
  NotEqual: 'NotEqual',
};

const isFieldVisible = (fieldRawPath, schema, formData) => {
  const fieldName = fieldRawPath
    .replace('[\'', '.')
    .replace('\']', '')
    .substring(1);

  const visibilityOptionsPath = `properties.${fieldName.replaceAll('.', '.properties.')}.options.visibility`;
  const visibilityOptions = get(schema, visibilityOptionsPath);
  if (!visibilityOptions) {
    return true;
  }

  const dependentFieldValue = get(formData, visibilityOptions.fieldId);

  switch (visibilityOptions.fieldCondition) {
    case AvailableVisibilityConditions.Equal:
      if (dependentFieldValue === visibilityOptions.fieldValue) {
        return true;
      }
      break;
    case AvailableVisibilityConditions.Greater:
      if (dependentFieldValue > visibilityOptions.fieldValue) {
        return true;
      }
      break;
    case AvailableVisibilityConditions.GreaterOrEqual:
      if (dependentFieldValue >= visibilityOptions.fieldValue) {
        return true;
      }
      break;
    case AvailableVisibilityConditions.Less:
      if (dependentFieldValue < visibilityOptions.fieldValue) {
        return true;
      }
      break;
    case AvailableVisibilityConditions.LessOrEqual:
      if (dependentFieldValue <= visibilityOptions.fieldValue) {
        return true;
      }
      break;
    case AvailableVisibilityConditions.NotEqual:
      if (dependentFieldValue !== visibilityOptions.fieldValue) {
        return true;
      }
      break;
    default:
      break;
  }

  return false;
};

const removeInvisibleFieldsErrors = (errors, schema, formData) => {
  const errorsGroupedByType = groupBy(
    errors,
    (error) => (!['required', 'type'].includes(error.name)),
  );

  const validationErrors = errorsGroupedByType.true
    ? [...errorsGroupedByType.true]
    : [];
  const requiredFieldErrors = errorsGroupedByType.false
    ? [...errorsGroupedByType.false]
    : null;

  if (requiredFieldErrors && requiredFieldErrors.length > 0) {
    requiredFieldErrors.forEach((requiredField) => {
      if (isFieldVisible(requiredField.property, schema, formData)) {
        validationErrors.push(requiredField);
      }
    });
  }

  return validationErrors;
};

const transformErrors = (errors, schema, uiSchema, formData) => {
  // Usuń błędy walidacji z pól niewidocznych.
  errors = removeInvisibleFieldsErrors(errors, schema, formData);
  // Dodaj błędy walidacji związane z ograniczeniami.
  getFieldLimitationsErrors(uiSchema, formData, errors);

  logger.debug('Walidacja:', errors);

  return errors
    .filter((error) => error.name !== 'multipleOf') // TODO Tymczasowe obejście.
    .map((error) => {
      if (error.name === 'required' || error.name === 'enum') {
        return {
          ...error,
          message: 'Pole wymagane.',
        };
      }

      if (error.name === 'type') {
        return {
          ...error,
          message: 'Pole nie zostało wypełnione lub posiada nieprawidłowy format.',
        };
      }

      const key = error.property.substring(1);
      const value = get(schema, key);

      let schemaKey = '';
      key.split('.').forEach((part) => {
        if (part.indexOf('[') > 0) {
          schemaKey += `properties.${part.substring(0, part.indexOf('['))}.`;
        } else {
          schemaKey += `properties.${part}.`;
        }
      });
      let type = get(schema, `${schemaKey}type`);
      if (type === 'array') {
        type = get(schema, `${schemaKey}items.type`);
      }

      if (
        ['required', 'type'].includes(error.name)
        && type === 'integer'
        && (!isNumber(value) || (isNumber(value) && !Number.isInteger(value)))
      ) {
        return {
          ...error,
          message: 'Nieprawidłowy format.',
        };
      }

      if (
        ['required', 'type'].includes(error.name)
        && type === 'number'
        && !isNumber(value)
      ) {
        return {
          ...error,
          message: 'Nieprawidłowy format.',
        };
      }

      if (type === 'integer' || type === 'number') {
        if (error.name === 'type') {
          return {
            ...error,
            message: 'Nieprawidłowy format.',
          };
        }
      }

      if (error.name === 'minimum') {
        return {
          ...error,
          message: `Minimalna dopuszczalna wartość to ${error.params.limit}.`,
        };
      }

      if (error.name === 'maximum') {
        return {
          ...error,
          message: `Maksymalna dopuszczalna wartość to ${error.params.limit}.`,
        };
      }

      if (error.name === 'maxLength') {
        return {
          ...error,
          message: `Maksymalna dopuszczalna liczba znaków to ${error.params.limit}.`,
        };
      }

      // if (error.name === 'multipleOf') {
      //   return {
      //     ...error,
      //     message: `Maksymalna dopuszczalna liczba miejsc po przecinku to ${countBy(error.params.multipleOf.toString())['0'] || 0}.`,
      //   };
      // }

      if (error.name === 'limitations') {
        return {
          ...error,
        };
      }

      return error;
    });
};

export default transformErrors;
